import { OwnershipProperty } from "src/components";
import { ActionItemDetailDto, useEditActionItemOwners, UserDto } from "src/http";

interface IProps {
  actionItem: ActionItemDetailDto;
  onChanged?: (actionItemGuid: string, actionItemDescription: string, removedOwners: UserDto[]) => void;
}

const ActionItemOwnershipProperty = (props: IProps) => {
  const { mutate: editOwners } = useEditActionItemOwners();

  function handleSaveClicked(updatedOwners: UserDto[], removedOwners: UserDto[], primaryOwner: UserDto | null) {
    editOwners(
      {
        actionItemGuid: props.actionItem.guid,
        planGuid: props.actionItem.teamPlanSection.planGuid,
        owners: updatedOwners,
        primaryOwner: primaryOwner,
      },
      {
        onSuccess: () => {
          props.onChanged?.(props.actionItem.guid, props.actionItem.description, removedOwners);
        },
      }
    );
  }

  return (
    <OwnershipProperty
      owners={props.actionItem.owners}
      primaryOwner={props.actionItem.primaryOwner}
      userCanEdit={props.actionItem.userCanEdit}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { ActionItemOwnershipProperty };
